import React from "react";

const PageTitle = (props) => {
  return (
    <div className="page-title" {...props}>
      {props.title}
    </div>
  );
};

export default PageTitle;



// WEBPACK FOOTER //
// ./src/components/common/pageTitle.js